
import {useCallback, useState} from 'react'
import {backendRequest} from '../../../../../../common/utils/requests'

type UseToggleSubscriptionParams = {
  onSuccess: (isSubscribed: boolean) => Promise<void>
  onError: (isSubscribed: boolean, error: unknown) => void
}

type UseToggleSubscriptionReturnValue = {
  loading: boolean
  toggleSubscription: (offerId: number, isSubscribed: boolean) => Promise<void>
}

const fetchAPI = async (accountId: number, offerId: number, isSubscribed: boolean): Promise<void> => {
  const response = await backendRequest(`/api/v2/dashboard/accounts/${accountId}/providers/brokeree/subscriptions`, {
    offerId,
    isSubscribed,
  }, 'PATCH')

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Failed to change subscription status ${response.status} ${response.statusText} ${errorText}`)
  }
}

export const useToggleSubscription = (accountId: number, params: UseToggleSubscriptionParams): UseToggleSubscriptionReturnValue => {
  const {onSuccess, onError} = params

  const [loading, setLoading] = useState(false)

  const toggleSubscription = useCallback(async (offerId: number, isSubscribed: boolean) => {
    try {
      setLoading(true)
      await fetchAPI(accountId, offerId, isSubscribed)
      await onSuccess(isSubscribed)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error fetching me:', e)
      onError(isSubscribed, e)
    } finally {
      setLoading(false)
    }
  }, [accountId, onError, onSuccess])

  return {loading, toggleSubscription}
}
